import React, { useState } from 'react';
import styled from 'styled-components';
import { Buttons, CancelButton, DeleteButton, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';

const Description = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

function RemoveMicrosoftTeamsConfirmation({ onClose, onRemove }) {
  const api = useApi();
  const isMounted = useIsMounted();
  const { workspace } = useWorkspace();
  const [isRemoving, setIsRemoving] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  async function handleRemove() {
    setIsRemoving(true);
    setErrorMessage();

    try {
      await api.www.workspaces(workspace.id).integrations().microsoft.teams.remove();

      if (typeof onRemove === 'function') {
        await onRemove();
      }
    } catch ({ message }) {
      if (message) {
        setErrorMessage(message);
      } else {
        setErrorMessage('There was a problem completing your request. Please try again later.');
      }
    } finally {
      if (isMounted.current) {
        setIsRemoving(false);
      }
    }
  }

  return (
    <ModalCard title="Remove Microsoft 365 Integration" onClose={onClose}>
      <ModalCard.Body>
        <Description>
          Removing Microsoft 365 disconnects your Microsoft 365 organization and removes the Microsoft Teams settings,
          project channels and every member&apos;s Teams link. Time entries are not affected.
        </Description>
        {errorMessage && <FormMessage.Error spaceTop>{errorMessage}</FormMessage.Error>}
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <DeleteButton isLoading={isRemoving} onClick={handleRemove}>
            Remove
          </DeleteButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default RemoveMicrosoftTeamsConfirmation;
